import { AccountHierarchyResponseTypeEnum } from '@monetize/types/app';
import { useGetAccountHierarchyById } from '../api/accountsService';
import { useFlags } from '../services/launchDarkly';

/**
 * Whether account-hierarchy features (quote offering groups) apply to a quote:
 * the flag is on and the quote's account actually has child accounts to ship or
 * bill to.
 */
export const useAccountHierarchyEnabled = (accountId?: string) => {
  const { accountHierarchy } = useFlags();

  const { data: accountHierarchyResponse } = useGetAccountHierarchyById(
    accountId || '',
    AccountHierarchyResponseTypeEnum.NESTED,
    { enabled: !!accountId },
  );

  return !!accountHierarchy && !!accountHierarchyResponse?.children?.length;
};
